const benefits = [
  {
    icon: 'ri-refresh-line',
    title: 'Updated Finds',
    description: 'Our Sugargoo spreadsheet is refreshed regularly with the latest community-discovered products, ensuring you never miss trending items or new seller listings.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Better Decisions',
    description: 'Compare products side by side with detailed QC photos, seller ratings, and pricing data before making any purchase commitment.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Save Money',
    description: 'Find the best price-to-quality ratios across multiple sellers and optimize your shipping strategy to minimize international delivery costs.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Beginner Friendly',
    description: 'Designed for first-time Sugargoo users with clear instructions, direct product links, and step-by-step shopping guides.',
  },
];

export default function BenefitsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-4">
            Why Use Our <strong className="text-accent-600">Sugargoo Spreadsheet</strong>?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Thousands of shoppers trust our curated database for smarter, faster, and more affordable China shopping.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {benefits.map((benefit) => (
            <div
              key={benefit.title}
              className="bg-background-100 rounded-xl p-6 md:p-7 hover:bg-background-200/70 transition-colors group cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-xl mb-5 group-hover:bg-accent-200 transition-colors">
                <i className={`${benefit.icon} text-accent-600 text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                {benefit.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}